let instance = null;

export default class ExternalScriptLoader {
    constructor() {
        if (!instance) {
            instance = this;
            this.requestedScripts = {};
        }
        return instance;
    }

    loaded(url, type = 'text/javascript') {
        // If the script has already been requested, return the existing promise
        if (this.requestedScripts[url]) {
            return this.requestedScripts[url];
        }

        // Create a new native promise
        this.requestedScripts[url] = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = url;
            script.type = type;
            script.async = true;

            script.onload = () => resolve();
            script.onerror = () => {
                // Delete it from cache on failure so a retry can be attempted later
                delete this.requestedScripts[url];
                reject(new Error(`Script load failed for ${url}`));
            };

            document.head.appendChild(script);
        });

        return this.requestedScripts[url];
    }
}